module.exports = __webpack_public_path__ + "img/cfff6ab.jpg";